import React from 'react'
import styled from 'styled-components'

import { isSupportDomain } from '../../../lib/currentDomain'
import InlineAlert, { AlertType } from '../../components/InlineAlert'
import { ChargePoint, useExternalServerGetByChargePointIdQuery } from '../../redux/api/web-api'
import useText from '../../hooks/useText'
import { getChargerIcon } from '../../utils/chargePointUtils'
import ChargePointTypeLabel from '../../components/ChargePointTypeLabel'

export const SPageControlsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 20px 0;
`

export type ChargePointPageControlsProps = {
    chargePoint: ChargePoint
}

export function ChargePointPageControls({ chargePoint }: ChargePointPageControlsProps): React.ReactElement {
    const text = useText()

    const { data: externalServerForChargePoint } = useExternalServerGetByChargePointIdQuery({
        chargePointId: chargePoint.id,
    })

    return (
        <>
            <div className="grid gap-4 mt-1 mb-2">
                {getChargerIcon(chargePoint, 100)}

                <div className="flex flex-column mt-4">
                    <div>
                        <ChargePointTypeLabel
                            chargePoint={chargePoint}
                            editable={chargePoint?.ocppEnabled && !isSupportDomain && chargePoint.isOcpp ? false : true}
                        />
                    </div>
                    <div className="grid gap-1 text-700 mt-1" data-testid="chargepoint-name"></div>
                </div>
            </div>
            {chargePoint?.ocppEnabled && !isSupportDomain && (
                <InlineAlert
                    text={
                        chargePoint?.isOcpp
                            ? text('lblChargerCPMSText', { name: externalServerForChargePoint?.description })
                            : text('lblChargerProxyText', { name: externalServerForChargePoint?.description })
                    }
                    alertType={AlertType.Info}
                    data-testid="relayActivated-msg"
                />
            )}
        </>
    )
}
